<template>
    <div class="row">
        <div class="col">
            <div class="d-flex align-items-end mb-3">
                <h4 class="mb-0">
                    {{ $tc('models.subscription') }}:
                </h4>
                <span class="text-muted ml-1">{{ model.description }}</span>
            </div>

            <div>
                <div
                    v-for="(d, index) in subscriptionData"
                    :key="index"
                    class="flex-row"
                >
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t(d.title) }}:
                        </span>

                        <currency
                            v-if="d.isCurrency"
                            v-model="d.value"
                        />
                        <span v-else>
                            {{ d.value }}
                        </span>
                    </div>
                </div>
            </div>

            <h4 class="mt-4 mb-2">
                {{ $tc('models.subscriptionline', 0) }}
            </h4>

            <table class="table table-sm table-actions">
                <thead>
                    <tr>
                        <th style="width:20%">
                            {{ $tc('subscriptionline.description') }}
                        </th>
                        <th
                            class="text-right"
                            style="width:15%"
                        >
                            {{ $tc('subscriptionline.quantity') }}
                        </th>
                        <th
                            class="text-right"
                            style="width:10%"
                        >
                            {{ $tc('subscriptionline.price') }}
                        </th>
                        <th
                            class="text-right"
                            style="width:10%"
                        >
                            {{ $tc('subscriptionline.total') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="tr in lines"
                        :key="tr.id"
                    >
                        <td class="text-nowrap">
                            {{ tr.description }}
                        </td>
                        <td class="text-right">
                            {{ tr.quantity }}
                        </td>
                        <td class="text-right">
                            <currency v-model="tr.price" />
                        </td>
                        <td class="text-right">
                            <currency v-model="tr.total" />
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="flex-row">
                <div class="text-align-end">
                    <span class="font-weight-bold">
                        {{ $t('subscriptionline.total') }}:
                    </span>
                    <currency v-model="model.total" />
                    <br>
                    <span class="font-weight-bold">
                        {{ $t('subscription.monthly') }}:
                    </span>
                    <currency v-model="model.mrr" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Show from '@/mixins/Show';
import store from '@/store';

export default {
    mixins: [Show],
    data () {
        return {
            lines: this.model.lines,
        };
    },
    computed: {
        periodLabel () {
            const period = this.$t(`period.${this.model.period}`);
            if (this.model.periods === 1) {
                return period;
            }

            return `${period} (${this.$t('subscription.per_periods')} ${this.model.periods})`;
        },
        subscriptionData () {
            return [
                {
                    title: 'subscription.started-at',
                    value: this.$dayjs(this.model.billing_start_date).format('DD MMM YY'),
                },
                {
                    title: 'subscription.period',
                    value: this.periodLabel,
                },
                {
                    title: 'subscription.period-start',
                    value: this.$dayjs(this.model.start_period).format('DD MMM YY'),
                },
                {
                    title: 'subscription.period-end',
                    value: this.$dayjs(this.model.end_period).format('DD MMM YY'),
                },
                {
                    title: 'subscription.termination-date',
                    value: this.model.termination_date ? this.$dayjs(this.model.termination_date).format('DD MMM YY') : `(${this.$t('defaults.none')})`,
                },
            ];
        },
        store () {
            return store;
        },
    },
};
</script>
